import dayjs from "dayjs";

function generateColorGradient(hex, steps) {
  function hexToRgb(hex) {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);
    return [r, g, b];
  }

  function rgbToHex(r, g, b) {
    return `#${((1 << 24) | (r << 16) | (g << 8) | b)
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
  }

  let [r, g, b] = hexToRgb(hex);
  let gradient = [];

  let maxWhite = 230; // Limit to near-white instead of full white (255)

  for (let i = 0; i < steps; i++) {
    let factor = i / (steps - 1);
    let newR = Math.round(r + (maxWhite - r) * factor);
    let newG = Math.round(g + (maxWhite - g) * factor);
    let newB = Math.round(b + (maxWhite - b) * factor);
    gradient.push(rgbToHex(newR, newG, newB));
  }

  return gradient;
}

function formatDateToIsoString(date) {
  return dayjs(date).format("YYYY-MM-DD");
}

export function formatDateTimeLocal(date) {
  return dayjs(date).format("YYYY-MM-DDTHH:mm");
}

function generateWeeklyLabels(numWeeks) {
  const labels = [];
  const today = new Date();
  const startDate = new Date();
  startDate.setDate(today.getDate() - numWeeks * 7);

  for (let i = 0; i < numWeeks; i++) {
    const weekStart = new Date(startDate);
    weekStart.setDate(startDate.getDate() + i * 7);

    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    const formatDate = (date) =>
      date.getDate().toString().padStart(2, "0") +
      "/" +
      (date.getMonth() + 1).toString().padStart(2, "0");

    labels.push(`${formatDate(weekStart)} - ${formatDate(weekEnd)}`);
  }

  return labels;
}
function flattenObject(obj) {
  const result = {};

  function recurse(current, propertyPrefix = "") {
    if (
      typeof current !== "object" ||
      current === null ||
      current instanceof Date
    ) {
      result[propertyPrefix] = current;
      return;
    }

    for (const key in current) {
      const value = current[key];
      const newPrefix = propertyPrefix ? `${propertyPrefix}.${key}` : key;

      if (
        typeof value === "object" &&
        value !== null &&
        !(value instanceof Date)
      ) {
        recurse(value, newPrefix);
      } else {
        result[newPrefix] = value;
      }
    }
  }

  recurse(obj);
  return result;
}

function getTelephoneWarning(telephone) {
  const tel = telephone?.trim();
  if (!tel) return null;

  if (/^69/.test(tel)) {
    return /^69\d{8}$/.test(tel) ? null : "Greek mobile (69...) must be exactly 10 digits, no spaces";
  }
  if (/^210/.test(tel)) {
    return /^210\d{7}$/.test(tel) ? null : "Greek landline (210...) must be exactly 10 digits, no spaces";
  }
  if (tel.startsWith("+30")) {
    return /^\+30\d{10}$/.test(tel) ? null : "Greek number with +30 must be 13 characters: +30 followed by 10 digits";
  }
  if (/^30/.test(tel)) {
    return "Greek number starting with 30 is missing the + prefix (use +30...)";
  }
  if (!tel.startsWith("+")) {
    return "Non-Greek numbers must include country code (e.g. +44...)";
  }
  return /^\+\d+$/.test(tel) ? null : "Number should contain only digits after the country code (+)";
}

export {
  generateColorGradient,
  generateWeeklyLabels,
  flattenObject,
  formatDateToIsoString,
  getTelephoneWarning,
};
